var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 0.857147C36.7798 0.857147 47.1412 11.2186 47.1412 24C47.1412 36.7814 36.7798 47.1429 23.9983 47.1429C11.2169 47.1429 0.855469 36.7814 0.855469 24C0.855469 11.2186 11.2169 0.857147 23.9983 0.857147ZM23.9983 3.75C12.8146 3.75 3.74833 12.8162 3.74833 24C3.74833 35.1838 12.8146 44.25 23.9983 44.25C35.1821 44.25 44.2483 35.1838 44.2483 24C44.2483 12.8162 35.1821 3.75 23.9983 3.75ZM32.6184 17.1915C33.1833 16.6266 34.0991 16.6266 34.664 17.1915C35.2288 17.7564 35.2288 18.6722 34.664 19.2371L21.164 32.7371C20.5991 33.3019 19.6833 33.3019 19.1184 32.7371L12.3684 25.9871C11.8035 25.4222 11.8035 24.5064 12.3684 23.9415C12.9333 23.3766 13.8491 23.3766 14.414 23.9415L20.1412 29.6687L32.6184 17.1915Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.aa65b5f3d3bf112ec3a3913da82b6184.svg";
export { ForwardRef as ReactComponent };